module.exports = __webpack_public_path__ + "fonts/ubuntu-v14-latin-regular.1cac021.woff";